/* eslint-disable no-shadow */
import { SET_SLIDEOUT, BACK_SLIDEOUT } from '../../types/setters';
import { GET_SLIDEOUT_STACK } from '../../types/getters';

/**
 * @returns {import("./slideoutStore").SlideoutStore}
 */
export function state() {
  return {
    slideoutStack: [],
  };
}

/**
 * @param {import("./slideoutStore").SlideoutStore} state
 * @param {object} payload
 * @param {Slideout} payload.slideout
 */
export const mutations = {
  /**
   * @param {import("./slideoutStore").SlideoutStore} state
   * @param {Slideout} slideout
   */
  [SET_SLIDEOUT](state, slideout) {
    state.slideoutStack.unshift(slideout);
  },
  /**
   * @param {import("./slideoutStore").SlideoutStore} state
   */
  [BACK_SLIDEOUT](state) {
    state.slideoutStack.shift();
  },
};

export const getters = {
  /**
   * @param {import("./slideoutStore").SlideoutStore} state
   * @returns {Slideout[]}
   */
  [GET_SLIDEOUT_STACK](state) {
    return state.slideoutStack;
  },
};
